import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-bom-radio-delivery-options',
    templateUrl: './bom-radio-delivery-options.component.html',
    styleUrls: ['./bom-radio-delivery-options.component.scss'],
    standalone: false
})
export class BomRadioDeliveryOptionsComponent {
  @Input() isChecked: boolean;
  @Input() deliveryDisabled: boolean;
  @Input() isDirectDelivery: boolean;

  @Output() changed = new EventEmitter<boolean>();

  deliveryChanged() {
    if (this.isChecked) {
      return;
    }

    this.changed.emit(this.isDirectDelivery);
  }
}
